<rcp-com-card
    cardClass="bg-white border border-gray-border"
    [hasHeader]="false">
    <div
        class="flex flex-col h-full p-4"
        rcpComLoadingOverlay
        [isLoading]="isLoading">
        <h6 class="font-semibold uppercase mb-3">Aging Trend Detail</h6>

        @if (chartOptions) {
            <ag-charts
                style="height: 100%"
                [options]="chartOptions"></ag-charts>
        } @else if (!chartOptions && !isLoading) {
            <p class="text-center text-sm">No data to display</p>
        }
    </div>
</rcp-com-card>
